"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AutoflowTaskSurvey () {
        return AutoflowTaskSurvey;
    },
    get AutoflowTaskSurveyOpenEmail () {
        return AutoflowTaskSurveyOpenEmail;
    },
    get AutoflowTaskSurveyOpenEmailResponse () {
        return AutoflowTaskSurveyOpenEmailResponse;
    },
    get SurveyParticipantModel () {
        return SurveyParticipantModel;
    }
});
const _zod = require("zod");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _taskbase = require("./task-base");
const SurveyParticipantModel = _zod.z.object({
    _id: _utilsisomorphic.transformObjectId,
    email: _zod.z.string(),
    name: _zod.z.string()
});
const AutoflowTaskSurveyOpenEmail = _taskbase.AutoflowTaskBase.extend({
    taskType: _zod.z.literal("survey:open-email"),
    config: _zod.z.object({
        surveyId: _utilsisomorphic.transformObjectId,
        userId: _utilsisomorphic.transformObjectId,
        urlPrefix: _zod.z.string(),
        participants: _zod.z.array(SurveyParticipantModel).optional()
    })
});
const AutoflowTaskSurveyOpenEmailResponse = _taskbase.AutoflowTaskBaseResponse.extend({
    taskType: _zod.z.literal("survey:open-email")
});
const AutoflowTaskSurvey = _zod.z.discriminatedUnion("taskType", [
    AutoflowTaskSurveyOpenEmail
]);
